import Api from "./Api";

async function deleteBill(token,id,cancelToken){
    const params={id}
    return await Api.delete('/api/v1/Providers/Bills', {
        params,
        headers: {
            "Authorization": `Bearer ${token}`
        },
        cancelToken,
    })
}
export default deleteBill;